export const JiraIssueLinkSchemaType = 'issuelink';
const TEAM_FIELD_KEY = 'customfield_10001';

/**
 based on https://evinced.atlassian.net/browse/EW-6689
 custom field "customfield_10001" (team) was not visible.
 After making it visible, we also need to reformat the option object.
 */
export const isTeamField = (fieldKey?: string): boolean => {
	return fieldKey === TEAM_FIELD_KEY;
};
